export const BaseUrlConnection = () => {
  const APPLICATION_MODE = process.env.NODE_ENV?.trim() || "development";

  if (APPLICATION_MODE === "development") {
    const isLocalhost = window.location.hostname === "localhost";
    return isLocalhost
      ? process.env.REACT_APP_LOCAL_HOST_DOMAIN_WITH_SERVER_PORT
      : process.env.REACT_APP_LOCAL_NETWORK_DOMAIN_WITH_SERVER_PORT;
  }

  if (APPLICATION_MODE === "production") {
    return process.env.REACT_APP_PRODUCTION_NETWORK_DOMAIN || "";
  }

  console.warn("Unhandled application mode:", APPLICATION_MODE);
  return "";
};
